(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-premium-home"] && !Shopify.designMode) return;
  try {
    
  const updateTechHonestyWeeklyCountdown = () => {
    document.querySelectorAll('[data-weekly-deal-countdown]').forEach((timer) => {
      const output = timer.querySelector('[data-weekly-deal-time]');
      const end = new Date(timer.dataset.weeklyDealEnd);
      if (!output || Number.isNaN(end.getTime())) return;

      const remaining = end.getTime() - Date.now();
      if (remaining <= 0) {
        output.innerHTML = '<span><b>00</b><em>Days</em></span><span><b>00</b><em>Hrs</em></span><span><b>00</b><em>Mins</em></span><span><b>00</b><em>Secs</em></span>';
        timer.setAttribute('aria-label', 'Weekly deal ended');
        return;
      }

      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      output.innerHTML = [
        `<span><b>${String(days).padStart(2, '0')}</b><em>Days</em></span>`,
        `<span><b>${String(hours).padStart(2, '0')}</b><em>Hrs</em></span>`,
        `<span><b>${String(minutes).padStart(2, '0')}</b><em>Mins</em></span>`,
        `<span><b>${String(seconds).padStart(2, '0')}</b><em>Secs</em></span>`
      ].join('');
    });
  };

  updateTechHonestyWeeklyCountdown();
  setInterval(updateTechHonestyWeeklyCountdown, 1000);

  } catch(e) { console.error(e); }
})();
})();
